import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import { useDelayMount } from '../../Atoms/Loading/useDelayMount.js';
import styles from './InlineLoading.module.css.js';

const InlineLoading = ({ delay = 0 }) => {
    const mounted = useDelayMount(delay);
    const component = (jsxRuntimeExports.jsxs("span", { children: [jsxRuntimeExports.jsx("span", { className: styles.dot }), jsxRuntimeExports.jsx("span", { className: styles.dot }), jsxRuntimeExports.jsx("span", { className: styles.dot })] }));
    if (delay === 0) {
        return component;
    }
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: mounted && component });
};

export { InlineLoading };
//# sourceMappingURL=InlineLoading.js.map
